module.exports = __webpack_public_path__ + "img/default.ed2789e3.png";